import { render } from "./PerformanceChart6.vue?vue&type=template&id=5434f3fc&ts=true"
import script from "./PerformanceChart6.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart6.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__